export default __webpack_public_path__ + "static/media/trash-icon.81a24dec.svg";